/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeploymentAndConfigUpdateDetails { 
    deployment_id?: string;
    existing_support_url?: string;
    failure_reason?: string;
    irr_fqdn?: string;
    irr_ip?: string;
    streamline_fqdn_success?: boolean;
    streamline_support_org_success?: boolean;
}

